
export default {
  name: 'CardPromotion',
}
